import { render, staticRenderFns } from "./BaseAutocompleteDeprecated.vue?vue&type=template&id=51053690&"
import script from "./BaseAutocompleteDeprecated.vue?vue&type=script&lang=js&"
export * from "./BaseAutocompleteDeprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
